export default __webpack_public_path__ + "static/media/english-to-german-screenshot-06.d604fbd1.png";